/*网站首页界面*/
const IndexWrap = () => import(/* webpackChunkName: "IndexWrap" */'../views/HomePage/IndexWrap.vue');
/*首页子模块*/
const PageWrap = () => import(/* webpackChunkName: "PageWrap" */'../views/HomePage/IndexPage/PageWrap.vue');
const HotelWrap = () => import(/* webpackChunkName: "HotelWrap" */'../views/HomePage/IndexPage/HotelWrap.vue');
const HotelActivity = () => import(/* webpackChunkName: "HotelActivity" */'../views/HomePage/IndexPage/HotelActivity.vue');
const AboutUs = () => import(/* webpackChunkName: "AboutUs" */'../views/HomePage/IndexPage/AboutUs.vue');
const MapSearch = () => import(/* webpackChunkName: "AboutUs" */'../views/HomePage/IndexPage/MapSearch.vue');
const LeatherCity = () => import(/* webpackChunkName: "LeatherCity" */'../views/HomePage/IndexPage/LeatherCity.vue');

const DetailWrap = () => import(/* webpackChunkName: "DetailWrap" */'../views/HomePage/HotelDetails/index.vue');
const ActivityDetail = () => import(/* webpackChunkName: "ActivityDetail" */'../views/HomePage/IndexComps/HotelActivity/ActivityDetail.vue');
const ShopCart = () => import(/* webpackChunkName: "ShopCart" */'../views/HomePage/IndexComps/ShopCart/ShopCart.vue');
const ScenicShopCart = () => import(/* webpackChunkName: "ScenicShopCart" */'../views/HomePage/IndexComps/ShopCart/ScenicShopCart.vue');
const BrandShopCart = () => import(/* webpackChunkName: "BrandShopCart" */'../views/HomePage/IndexComps/ShopCart/BrandShopCart.vue');
const ListWrap = () => import(/* webpackChunkName: "ListWrap" */'../views/HomePage/IndexComps/HotelPage/ListWrap.vue');
const CompanyDetail = () => import(/* webpackChunkName: "CompanyDetail" */'../views/HomePage/IndexComps/AboutUs/CompanyDetail.vue');
const TeamDetail = () => import(/* webpackChunkName: "TeamDetail" */'../views/HomePage/IndexComps/AboutUs/TeamDetail.vue');
const JoinUs = () => import(/* webpackChunkName: "JoinUs" */'../views/HomePage/IndexComps/AboutUs/JoinUs.vue');
const ContactUs = () => import(/* webpackChunkName: "ContactUs" */'../views/HomePage/IndexComps/AboutUs/ContactUs.vue');

const HalfMW = () => import(/* webpackChunkName: "HalfMW" */'../views/HomePage/IndexComps/HotelPage/HalfMountainWater.vue');

const OfferMapPage = () => import(/* webpackChunkName: "GuidesManage" */'../views/Order/OrderDetail/HotelOrder/OfferMapPage.vue')
export default [
  
  { path: '/OfferMapPage',name:'OfferMapPage', component: OfferMapPage, meta: { title: '订单雨-酒店地图' } },
  {
    path: '/',
    component: IndexWrap,
    redirect: '/index_page',
    children: [
      // {path: 'index_page', component: PageWrap, meta: {title: '订单雨官网-团队订酒店,团队订会场,团队订门票'}},
      {path: 'index_page', component: PageWrap, meta: {title: '预订单-测试专用，不对外开放'}},
      {path: 'leather_city', component: LeatherCity, meta: {title: '订单雨-浙北皮革城'}},
      {path: 'index_hotel',
        component: HotelWrap,
        children:[
          {path: '', component: ListWrap, meta: {title: '订单雨-酒店列表'}},
          {path: 'hotel_list_map', name:'hotelMapSearch',component: MapSearch, meta: {title: '订单雨-地图找酒店'}},
          {path: 'hotel_detail/:id', name:'hotelDetail',component: DetailWrap, meta: {title: '订单雨-酒店详情'}},
        ]
      },
      {path: 'index_homestay',
        component: HotelWrap,
        children:[  
          {path: '', component: ListWrap, meta: {title: '订单雨-民宿列表'}},
          {path: 'homestay_list_map', name:'homestayMapSearch', component: MapSearch, meta: {title: '订单雨-地图找民宿'}},
          {path: 'homestay_detail/:id', name:'homestayDetail', component: DetailWrap, meta: {title: '订单雨-民宿详情'}},
          {path: 'shop_car', name:'shopCar', component: ShopCart, meta: {title: '订单雨-购物车'}},
        ]
      },
      {path: 'index_scenic',
        component: HotelWrap,
        children:[
          {path: '',component: ListWrap, meta: {title: '订单雨-景区列表'}},
          {path: 'scenic_list_map', name:'scenicMapSearch', component: MapSearch, meta: {title: '订单雨-地图找景区'}},
          {path: 'scenic_detail/:id', name:'scenicDetail', component: DetailWrap, meta: {title: '订单雨-景区详情'}},
          {path: 'shop_car', component: ScenicShopCart, meta: {title: '订单雨-购物车'}},
        ]
      },
      {path: 'index_product',
        component: HotelWrap,
        children:[
          {path: '',component: ListWrap, meta: {title: '订单雨-度假产品列表'}},
          {path: 'product_list_map', name:'productMapSearch', component: MapSearch, meta: {title: '订单雨-地图找产品'}},
          {path: 'product_detail/:id', name:'productDetail', component: DetailWrap, meta: {title: '订单雨-度假产品详情'}},
          {path: 'shop_car', name:'orderProduct',component: ScenicShopCart, meta: {title: '订单雨-购物车'}},
        ]
      },
      {path: 'index_brand',
        component: HotelWrap,
        children:[
          {path: '',component: HalfMW, meta: {title: '订单雨-半山伴水'}},
          {path: 'brand_list_map', name:'brandMapSearch', component: MapSearch, meta: {title: '订单雨-地图找品牌馆'}},
          {path: 'brand_detail/:id/:name', name:'brandDetail', component: DetailWrap, meta: {title: '订单雨-品牌馆详情'}},
          {path: 'shop_car', component: BrandShopCart, meta: {title: '订单雨-购物车'}},
        ]
      },
      {path: 'index_hotel_activity', component: HotelActivity, meta: {title: '订单雨-酒店活动'}},
      {path: 'index_hotel_activity/activity_detail', component: ActivityDetail, meta: {title: '订单雨-酒店活动详情'}},
      {path: 'about_us',
        component: AboutUs,
        children: [
          {path: '', component: CompanyDetail, meta: {title: '订单雨-关于我们'}},
          {path: 'team_detail', component: TeamDetail, meta: {title: '订单雨-团队介绍'}},
          {path: 'join_us', component: JoinUs, meta: {title: '订单雨-诚征英才'}},
          {path: 'contact_us', component: ContactUs, meta: {title: '订单雨-联系我们'}}
        ]
      }
    ]
  }
]
